/**
 * True while a Unity Quit() / aborted-boot-then-Quit is actually in flight.
 *
 * Not a wall-clock mute. The player parks the canvas and waits for the quit
 * promise; this flag is the matching "engine is packing up" signal for the
 * PostHog backstop. The player also hang-releases park + this flag if Quit()
 * never settles.
 */

export const UNITY_TEARDOWN_HANG_TIMEOUT_MS = 30_000;

let teardownDepth = 0;

export function beginUnityTeardown(): void {
  teardownDepth += 1;
}

export function endUnityTeardown(): void {
  teardownDepth = Math.max(0, teardownDepth - 1);
}

export function isUnityTeardownActive(): boolean {
  return teardownDepth > 0;
}

/** Two frames so IDB / rAF completions queued during Quit() can finish. */
export function drainUnityTeardownEventLoop(): Promise<void> {
  if (typeof requestAnimationFrame !== "function") {
    return Promise.resolve();
  }
  return new Promise((resolve) => {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => resolve());
    });
  });
}

export function resetUnityTeardownForTests(): void {
  teardownDepth = 0;
}
